import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FundService } from 'src/app/services/fund/fund.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-dashboard-fund-approval-providers',
  templateUrl: './dashboard-fund-approval-providers.component.html',
  styleUrls: ['./dashboard-fund-approval-providers.component.scss'],
})
export class DashboardFundApprovalProvidersComponent implements OnInit {
  @Input() approval: any;

  @Output() onClick = new EventEmitter<MouseEvent>();

  loading = true;
  data;

  canView = false;

  columns: TableColumnList<any>[] = [
    {
      name: 'Empresa',
      cell: (row) => {
        const is_person = row.register.type === 'PF';
        const name = is_person
          ? row.register.person.full_name
          : row.register.company.corporate_name;
        const person = is_person ? row.register.person : row.register.company;
        const document = person?.document;

        return `
    <div class="dash-card-item p-0">
        <div class="dash-card-item-initials mr-3">
            <span>${row.register ? this.getInitials(name) : '-'}</span>
        </div>

        <div class="dash-card-item-content">
            <div class="dash-card-item-content-title">
                ${name}
            </div>
            <div class="dash-card-item-content-subtitle">
                ${this.formatDocument(document)}
            </div>
        </div>
    </div>
        `;
      },
      size: 2,
    },
    {
      name: 'Função',
      cell: (row) => `
        <div class="dash-card-item-content">
      <div class="dash-card-item-content-title">
          ${row.register.agent ? row.register.agent.name : '-'}
      </div>
      <div class="dash-card-item-content-subtitle">
          ${row.register.role.name}
      </div>
  </div>`,
    },
    {
      name: 'Data vínculo',
      cell: (row) => this.formatDate(row.register.created),
    },
    {
      name: '',
      cell: (row) => '',
    },
  ];
  //   data: Partial<ShareholderListValues>[] = [];

  constructor(
    private fundService: FundService,
    private api: ApiService,
    private route: ActivatedRoute,
    private toast: ToastService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    if (this.fundService.fundData.providers) {
      this.data = this.fundService.fundData.providers;
      this.loading = false;
    } else {
      this.getFundData();
    }

    this.canView = this.authService.verifyPermission(
      'de_can_view_fund_provider_details',
    );
  }

  formatDate(date: string) {
    const day = new Date(date).toLocaleDateString();
    const hours = new Date(date).toLocaleTimeString();
    return `${day} às ${hours}`;
  }

  getInitials(name: string) {
    return name
      .toUpperCase()
      .replace(/[^\w\s]/gi, '')
      .split(' ')
      .slice(0, 2)
      .map((word: string) => word.charAt(0))
      .join('');
  }

  formatDocument(document: any) {
    if (document) {
      if (document.type.name === 'CNPJ') {
        return (
          'CNPJ: ' +
          document.number.replace(
            /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
            '$1.$2.$3/$4-$5',
          )
        );
      } else {
        return (
          'CPF: ' +
          document.number.replace(
            /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
            '$1.$2.$3-$4',
          )
        );
      }
    } else {
      return '';
    }
  }

  getChoicesName(object: string, value: any) {
    const choices = this.fundService.choices;

    const choiceObject = choices[object];

    if (choiceObject) {
      return choiceObject.find((_choice: any) => _choice.value == value);
    }

    return { label: '', value: '' };
  }
  async getFundData() {
    try {
      const data = await this.api.get({
        route: 'api/v2/approvals/version/',
        params: {
          fund: this.route.snapshot.params.id,
          tab: 'shareholders',
        },
        token: true,
      });

      const fund = { ...data };

      if (fund[0].fund && fund[0].fund.length === 0) {
        this.loading = false;
        return;
      }

      this.data = fund[0].fund[0].service_providers;

      this.fundService.fundData = {
        ...this.fundService.fundData,
        providers: fund[0].fund[0].service_providers,
      };
    } catch (error) {
      this.toast.show(
        'error',
        'Erro',
        'Erro ao carregar prestadores de serviços: ' + error,
      );
    }

    this.loading = false;
  }
}
